// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3m_x4","content":"style_content__E9FzS","collapseBtn":"style_collapseBtn__1S6Up"};